import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import { Divider, TextField, Typography } from "@mui/material";
import { PartDetails } from "./PartDetails";
import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";
import { mmRfqFormDataSelector } from "../../Redux/MMRfq/Selector";
import { setMmRfqFormData } from "../../Redux/MMRfq/actions";
import { useFileContext } from "./FileContext";

const ConfirmRfqDetails = ({ MM_RFQ_FORM_DATA }) => {
    const [value, setValue] = useState(
        MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MM_RFQ_Name
    );
    const [error, setError] = useState(false);
    const dispatch = useDispatch();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target.value.toUpperCase();
        const regex = /^[a-zA-Z0-9\s]*$/;

        if (input?.trim()?.length <= 100 && regex.test(input)) {
            setValue(input);
            setError(false);

            const updatedArray = [...MM_RFQ_FORM_DATA];
            updatedArray[0] = {
                ...updatedArray[0],
                Rfq_Details: {
                    ...updatedArray[0].Rfq_Details,
                    MM_RFQ_Name: input
                }
            };

            if (MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MM_RFQ_Name !== input) {
                dispatch(setMmRfqFormData(updatedArray));
            }
        } else {
            setError(true); // Or set a custom message
        }
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" mb={2}>
                Confirm RFQ Details & Part Details
            </Typography>
            <Typography variant="body1" mb={0}>
                RFQ Details
            </Typography>
            <Typography sx={{ color: "text.secondary" }} variant="body2" mb={3}>
                Please add any additional details for the internal RFQ to ensure
                precise communication with partners. These details could include
                technical specifications, delivery instructions, or any other
                special requirements
            </Typography>
            <Grid container spacing={2} mt={2} mb={2}>
                <Grid size={{ xs: 12, md: 3, lg: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", marginBottom: "0.5rem" }}
                    >
                        Company RFQ Name
                    </Typography>
                    <Typography variant="body1">
                        {MM_RFQ_FORM_DATA[0]?.Rfq_Details?.Customer_RFQ_Name ||
                            "-"}
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 3, lg: 3 }}>
                    <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", marginBottom: "0.5rem" }}
                    >
                        CORFQ ID
                    </Typography>
                    <Typography variant="body1">
                        {MM_RFQ_FORM_DATA[0]?.Rfq_Details?.CURFQ_ID || "-"}
                    </Typography>
                </Grid>

                {/* <Grid size={{ xs: 12, md: 3, lg: 3 }}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", marginBottom: "0.5rem" }}
          >
            MMRFQ ID
          </Typography>
          <Typography variant="body1">
            {MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MMRFQ_ID || "-"}
          </Typography>
        </Grid> */}
                {/* <Grid size={{ xs: 12, md: 3, lg: 3 }}>
          <TextField
            id="outlined-basic"
            label={
              <>
                MMRFQ Name <span style={{ color: "red" }}> *</span>
              </>
            }
            placeholder="Enter MMRFQ Name"
            variant="outlined"
            value={value}
            onChange={handleChange}
            error={
              error ||
              (MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MM_RFQ_Name.length <= 0 &&
                MM_RFQ_FORM_DATA[0].isNextButtomClicked == true)
            }
            helperText={
              error
                ? "Only letters and numbers allowed (max 100 characters)"
                : MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MM_RFQ_Name.length <= 0 &&
                    MM_RFQ_FORM_DATA[0].isNextButtomClicked == true
                  ? "MMRFQ Name Required"
                  : ""
            }
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            inputProps={{ autoComplete: "off" }}
          />
        </Grid> */}
            </Grid>

            <Divider />
            <Box sx={{ height: "400px", overflow: "auto" }}>
                <Typography variant="body1" mb={2} mt={2}>
                    Parts Details
                </Typography>
                {MM_RFQ_FORM_DATA[0]?.Part_Details?.length > 0
                    ? MM_RFQ_FORM_DATA[0]?.Part_Details?.map(
                          (item: any, index: number) => {
                              return (
                                  <PartDetails
                                      item={item}
                                      index={index}
                                      isNextButtomClicked={
                                          MM_RFQ_FORM_DATA[0]
                                              ?.isNextButtomClicked
                                      }
                                  />
                              );
                          }
                      )
                    : "No Parts Found"}
            </Box>
        </Box>
    );
};
const mapStateToProps = createStructuredSelector({
    MM_RFQ_FORM_DATA: mmRfqFormDataSelector
});

export default connect(mapStateToProps)(ConfirmRfqDetails);
